<template>
  <div v-show="visible" class="ql-confirm-dialog-mask">
    <div class="ql-confirm-dialog" :style="dialogStyle" role="dialog" aria-modal="true">
      <button class="ql-confirm-dialog-close" type="button" aria-label="关闭" @click="close">
        <img src="../../assets/icon_common_close_1.png" alt="" />
      </button>

      <div v-if="title" class="ql-confirm-dialog-title">{{ title }}</div>
      <div class="ql-confirm-dialog-content">
        <img v-if="icon" class="ql-confirm-dialog-icon" :src="icon" alt="" />
        <div class="ql-confirm-dialog-description">{{ description }}</div>
      </div>

      <div class="ql-confirm-dialog-actions">
        <button
          v-for="(button, index) in buttons"
          :key="button.key || index"
          class="ql-confirm-dialog-button"
          :style="button.style"
          type="button"
          @click="handleButtonClick(button)"
        >
          {{ button.text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QLConfirmDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: 400,
    },
    buttons: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dialogStyle() {
      return {
        width: typeof this.width === 'number' ? `${this.width}px` : this.width,
      };
    },
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    handleButtonClick(button) {
      this.$emit('button-click', button);
    },
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
};
</script>

<style lang="scss" scoped>
.ql-confirm-dialog-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}

.ql-confirm-dialog {
  position: relative;
  min-height: 208px;
  padding: 20px 24px;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.ql-confirm-dialog-close {
  position: absolute;
  top: 12px;
  right: 16px;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  img {
    display: block;
    width: 32px;
    height: 32px;
  }
}

.ql-confirm-dialog-title {
  padding-right: 26px;
  font-family: PingFangSC, 'PingFang SC';
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #262626;
}

.ql-confirm-dialog-content {
  display: flex;
  align-items: flex-start;
  flex: 1;
  padding-top: 34px;
}

.ql-confirm-dialog-icon {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  margin: 2px 10px 0 0;
}

.ql-confirm-dialog-description {
  font-family: PingFangSC, 'PingFang SC';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #262626;
  text-align: justify;
}

.ql-confirm-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.ql-confirm-dialog-button {
  width: 88px;
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 2px;
  background: #1890ff;
  font-family: PingFangSC, 'PingFang SC';
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #fff;
  cursor: pointer;
  box-sizing: border-box;
}
</style>